
import React, { useState, lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { FileText, Star } from "lucide-react";

const GamingPCsDropdown = lazy(() => import("./GamingPCsDropdown"));
const WorkstationsDropdown = lazy(() => import("./WorkstationsDropdown"));
const ComponentsDropdown = lazy(() => import("./ComponentsDropdown"));

const DesktopNavigation = () => {
  const [isNavInteracted, setIsNavInteracted] = useState(false);

  const handleInteraction = () => {
    if (!isNavInteracted) {
      setIsNavInteracted(true);
    }
  };

  return (
    <NavigationMenu className="hidden md:flex" onMouseEnter={handleInteraction}>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger>Gaming PCs</NavigationMenuTrigger>
          {isNavInteracted && (
            <Suspense fallback={null}>
              <GamingPCsDropdown />
            </Suspense>
          )}
        </NavigationMenuItem>

        <NavigationMenuItem>
          <NavigationMenuTrigger>Workstations</NavigationMenuTrigger>
          {isNavInteracted && (
            <Suspense fallback={null}>
              <WorkstationsDropdown />
            </Suspense>
          )}
        </NavigationMenuItem>

        <NavigationMenuItem>
          <NavigationMenuTrigger>Components</NavigationMenuTrigger>
          {isNavInteracted && (
            <Suspense fallback={null}>
              <ComponentsDropdown />
            </Suspense>
          )}
        </NavigationMenuItem>

        <NavigationMenuItem>
          <Link to="/support" className="flex items-center gap-1 px-4 py-2 text-sm">
            <span>Support</span>
          </Link>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <Link to="/articles" className="flex items-center gap-1 px-4 py-2 text-sm">
            <FileText className="h-4 w-4 mr-1" />
            <span>Articles</span>
          </Link>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <a href="https://www.trustpilot.com/review/battleforgepc.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 px-4 py-2 text-sm">
            <Star className="h-4 w-4 mr-1" />
            <span>Reviews</span>
          </a>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default DesktopNavigation;
